import type { PropertyPreviewProps } from "@firecms/core";
import { StarIcon, StarOutlineIcon } from "@firecms/ui";

const MAX_STARS = 3;

export function StarsPreview({ value, size }: PropertyPreviewProps<number>) {
  const iconSize = size === "small" ? "smallest" : "small";
  const earned =
    typeof value === "number" && Number.isFinite(value)
      ? Math.min(MAX_STARS, Math.max(0, Math.round(value)))
      : null;

  if (earned == null) {
    return <span className="text-xs text-surface-400">—</span>;
  }

  return (
    <span className="inline-flex items-center gap-0.5" title={`${earned}`}>
      {Array.from({ length: MAX_STARS }, (_, i) =>
        i < earned ? (
          <StarIcon key={i} size={iconSize} color="warning" />
        ) : (
          <StarOutlineIcon key={i} size={iconSize} color="disabled" />
        )
      )}
    </span>
  );
}
